var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel-form d-flex flex-column flex-fill h-100" },
    [
      _c("div", { staticClass: "row flex-fill" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _vm.loading
              ? [_vm._m(0)]
              : [
                  _vm.loadingError
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "alert alert-danger",
                            attrs: { role: "alert" },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.errorMsg) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    : [
                        _vm.pageHtml
                          ? [
                              _c("div", {
                                domProps: { innerHTML: _vm._s(_vm.pageHtml) },
                              }),
                            ]
                          : _vm.data
                          ? [
                              _c("div", { staticClass: "panel-form-data" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "accordion",
                                    attrs: { id: "formProperties" },
                                  },
                                  _vm._l(_vm.data, function (item, key, idx) {
                                    return _c(
                                      "div",
                                      {
                                        key: `card-info-${idx}`,
                                        staticClass: "card accordion",
                                      },
                                      [
                                        item.title
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "card-header",
                                                attrs: { id: `heading${key}` },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row no-gutters",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col",
                                                        attrs: {
                                                          "data-toggle":
                                                            "collapse",
                                                          "data-target": `#collapse${key}`,
                                                          "aria-controls": `collapse${key}`,
                                                          "aria-expanded":
                                                            idx == 0,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              item.title
                                                                ? item.title
                                                                : ""
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "collapse",
                                            class: { show: idx == 0 },
                                            attrs: {
                                              id: `collapse${key}`,
                                              "aria-labelledby": `heading${key}`,
                                              "data-parent": "#formProperties",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "card-body",
                                                class: { "px-0": !item.title },
                                              },
                                              [
                                                _c("table", [
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      item.data,
                                                      function (
                                                        propVal,
                                                        propKey
                                                      ) {
                                                        return _c(
                                                          "tr",
                                                          { key: propKey },
                                                          [
                                                            _c("td", [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    propKey
                                                                  ) +
                                                                  "\n                                                    "
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              [
                                                                _vm.isString(
                                                                  propVal
                                                                )
                                                                  ? [
                                                                      _vm._v(
                                                                        "\n                                                            " +
                                                                          _vm._s(
                                                                            propVal
                                                                          ) +
                                                                          "\n                                                        "
                                                                      ),
                                                                    ]
                                                                  : [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          domProps:
                                                                            {
                                                                              innerHTML:
                                                                                _vm._s(
                                                                                  _vm.renderItemVal(
                                                                                    propVal
                                                                                  )
                                                                                ),
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                              ],
                                                              2
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                ],
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-form-data loading" }, [
      _c("div", {}, [_c("div", { staticClass: "full-size-loader" })]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }